<template>
  <base-modal ref="modal" size="3xl">
    <base-card class="tw-overlow-auto">
      <div class="tw-flex tw-justify-between tw-border-b tw-border-gray-150 tw-py-4">
        <div class="tw-text-gray-800 tw-text-xl tw-my-auto">{{ planName }} Plan Terms and Conditions</div>
        <div class="tw-h-7 tw-flex tw-items-center">
          <base-icon @click="hide">
            <x-icon class="tw-h-6 tw-w-6" />
          </base-icon>
        </div>
      </div>
      <div class="tw-mt-6" id="printAgreement">
        <BusinessPlanAgreement
          :businessPlanId="businessPlanId"
          :priceCents="priceCents"
          :currency="currency"
          :downPaymentCents="downPaymentCents"
          :businessName="businessName"
          :termLength="termLength"
          :termInterval="termInterval"
          :cycleFrequency="cycleFrequency"
          :cycleInterval="cycleInterval"
          :serviceFeeCents="serviceFeeCents"
        ></BusinessPlanAgreement>
      </div>

      <div class="tw-flex tw-justify-end tw-mt-2 tw-gap-2">
        <base-button type="flat" @click="hide()">Close</base-button>
        <base-button type="secondary" @click="printAgreement('printAgreement', businessName, planName)">Print</base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import BusinessPlanAgreement from "@/views/business/business-plans/components/BusinessPlanAgreement.vue";
import { XIcon } from "@/assets/svgs";
export default {
  name: "BusinessPlans",
  components: {
    BusinessPlanAgreement,
    XIcon,
  },

  data() {
    return {
      planName: null,
      businessPlanId: null,
      priceCents: null,
      currency: null,
      downPaymentCents: null,
      businessName: null,
      termLength: null,
      termInterval: null,
      cycleFrequency: null,
      cycleInterval: null,
      serviceFeeCents: null,
      isLoading: false,
    };
  },
  methods: {
    reset() {
      this.planName = null;
      this.businessPlanId = null;
      this.priceCents = null;
      this.currency = null;
      this.downPaymentCents = null;
      this.businessName = null;
      this.termLength = null;
      this.termInterval = null;
      this.cycleFrequency = null;
      this.cycleInterval = null;
      this.serviceFeeCents = null;
    },
    show(planName, businessPlanId, priceCents, currency, downPaymentCents, businessName, termLength, termInterval, cycleFrequency, cycleInterval, serviceFeeCents) {
      this.reset();
      this.planName = planName;
      this.businessPlanId = businessPlanId;
      this.priceCents = priceCents;
      this.currency = currency;
      this.downPaymentCents = downPaymentCents;
      this.businessName = businessName;
      this.termLength = termLength;
      this.termInterval = termInterval;
      this.cycleFrequency = cycleFrequency;
      this.cycleInterval = cycleInterval;
      this.serviceFeeCents = serviceFeeCents;

      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    printAgreement(agreement, businessName, planName) {
      var printContents = document.getElementById(agreement).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = planName + " Terms and Conditions" + printContents;
      window.print();
      document.body.innerHTML = originalContents;
      location.reload();
    },
  },
};
</script>
